import { productListingSubtitle } from '../../utils/ikeaCatalogSubtitle';
import { formatSkuDisplay } from './orderInvoiceMath';
import { ikeaImageSrc } from '../../utils/ikeaImage';

function httpsProductImageUrl(raw) {
    const s = typeof raw === 'string' ? raw.trim() : '';
    if (!s || !/^https:\/\//i.test(s)) return '';
    return ikeaImageSrc(s);
}

function findExtraInfo(extraInfoLookup, sku) {
    if (!Array.isArray(extraInfoLookup) || sku == null) return undefined;
    return extraInfoLookup.find((x) => String(x.owner) === String(sku))?.extraInfo;
}

function findCartLineBySku(cart, sku) {
    const target = String(sku ?? '').trim();
    if (!target) return null;
    for (const row of cart || []) {
        const id = String(row.SKU ?? row.id ?? '').trim();
        if (id === target) return row;
    }
    return null;
}

function pdfLineImageUrl(row) {
    const raw = row?.img ?? row?.image ?? '';
    return httpsProductImageUrl(typeof raw === 'string' ? raw : '');
}

/**
 * @param {Array<{ SKU: string; amount: number }>} rows
 * @param {Array<{ owner: string; extraInfo: object }>|undefined} extraInfoLookup
 * @param {Array<Record<string, unknown>>|undefined} cart
 * @returns {Array<{ name: string; description: string; imageUrl: string; sku: string; qty: number }>}
 */
export function normalizeSkuListForPdf(rows, extraInfoLookup, cart) {
    if (!Array.isArray(rows)) return [];

    return rows.map((row) => {
        const skuRaw = row.SKU;
        const sku = formatSkuDisplay(skuRaw);
        const qty = Number(row.amount ?? 0);
        const extraInfo = findExtraInfo(extraInfoLookup, skuRaw);
        const cartLine = findCartLineBySku(cart, skuRaw);

        if (extraInfo) {
            return {
                name: String(extraInfo.name || '').trim() || sku || 'Item',
                description: productListingSubtitle(extraInfo),
                imageUrl: httpsProductImageUrl(extraInfo.image),
                sku,
                qty,
            };
        }

        if (cartLine) {
            const nameFromCart = String(cartLine.name || '').trim();
            return {
                name: nameFromCart || sku || 'Item',
                description: String(cartLine.description ?? cartLine.imageAlt ?? '').trim(),
                imageUrl: pdfLineImageUrl(cartLine),
                sku,
                qty,
            };
        }

        return {
            name: sku || 'Item',
            description: '',
            imageUrl: '',
            sku,
            qty,
        };
    });
}
